import React, { useEffect, useRef } from 'react';
import { createChart } from 'lightweight-charts';

const TradingViewChart = ({ ohlcvData, markers, height = 500 }) => {
  const chartContainerRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartContainerRef.current || !ohlcvData || ohlcvData.length === 0) return;

    if (chartRef.current) {
      chartRef.current.remove();
      chartRef.current = null;
    }

    const chart = createChart(chartContainerRef.current, {
      width: chartContainerRef.current.clientWidth,
      height: height,
      layout: { background: { color: '#0a0a0a' }, textColor: '#9ca3af', fontSize: 12 },
      grid: { vertLines: { color: '#1f2937' }, horzLines: { color: '#1f2937' } },
      crosshair: { mode: 0 },
      rightPriceScale: { borderColor: '#1f2937', scaleMargins: { top: 0.1, bottom: 0.2 } },
      timeScale: { borderColor: '#1f2937', timeVisible: false },
      localization: { locale: 'en-US' },
    });

    const candleSeries = chart.addCandlestickSeries({
      upColor: '#22c55e', downColor: '#ef4444',
      borderDownColor: '#ef4444', borderUpColor: '#22c55e',
      wickDownColor: '#ef4444', wickUpColor: '#22c55e',
    });
    candleSeries.setData(ohlcvData);

    if (markers && markers.length > 0) {
      candleSeries.setMarkers(
        markers.map(m => ({
          time: m.time,
          position: m.signal === 'AL' ? 'belowBar' : 'aboveBar',
          color: m.signal === 'AL' ? '#22c55e' : '#ef4444',
          shape: m.signal === 'AL' ? 'arrowUp' : 'arrowDown',
          text: m.signal,
        })).sort((a, b) => a.time - b.time)
      );
    }

    const volumeSeries = chart.addHistogramSeries({
      priceFormat: { type: 'volume' },
      priceScaleId: 'volume',
    });
    chart.priceScale('volume').applyOptions({ scaleMargins: { top: 0.8, bottom: 0 } });
    volumeSeries.setData(
      ohlcvData.map(d => ({
        time: d.time, value: d.volume,
        color: d.close >= d.open ? 'rgba(34,197,94,0.3)' : 'rgba(239,68,68,0.3)',
      }))
    );

    chart.timeScale().fitContent();
    chartRef.current = chart;

    const handleResize = () => {
      if (chartRef.current && chartContainerRef.current) {
        chartRef.current.applyOptions({ width: chartContainerRef.current.clientWidth });
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      if (chartRef.current) { chartRef.current.remove(); chartRef.current = null; }
    };
  }, [ohlcvData, markers, height]);

  return <div ref={chartContainerRef} className="w-full rounded-lg overflow-hidden" />;
};

export default TradingViewChart;
